import React from "react";
import PortfolioDetailFrame from "./src/components/portfolio-detail-frame";

export const wrapPageElement = ({ element, props }) => (
  <PortfolioDetailFrame location={props.location} pageContext={props.pageContext}>
    {element}
  </PortfolioDetailFrame>
);
